<script>
export default {
  name: 'UlDialogSelect',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    labelSubmit: {
      type: String,
      default: 'Выбрать',
    },
    labelCancel: {
      type: String,
      default: 'Отмена',
    },
    width: {
      type: String,
      default: '420px',
    },
    options: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: null,
      query: '',
    };
  },
  computed: {
    filter() {
      return this.options.length > 20;
    },
    items() {
      const query = this.query.toUpperCase();
      return this.options.filter(i => i.label.toUpperCase()
        .indexOf(query) > -1);
    },
  },
  methods: {
    cancel() {
      this.$emit('update:active', false);
      this.val = null;
    },
    submit() {
      if (!this.val) {
        return;
      }
      this.$emit('update:active', false);
      this.$emit('input', this.val);
      this.$emit('change', this.val);
      this.val = null;
    },
  },
};
</script>
<template>
  <UlDialog
    :active="active"
    class="ul-dialog-select"
    :width="width"
    :loading="loading"
  >
    <UlCardTitle border>
      {{title}}
      <div class="ul-dialog-select__filter" slot="btn">
        <UlFormInput
          v-model="query"
          placeholder="Фильтр..."
        />
        <i class="el-icon-search"></i>
      </div>
    </UlCardTitle>
    <div class="ul-dialog-select__wrap">
      <div class="ul-dialog-select__body">
        <div
          v-for="item in items"
          :key="item.value"
          class="ul-dialog-select__item"
        >
          <UlFormRadio
            v-model="val"
            :item="item"
          ></UlFormRadio>
        </div>
        <div class="ul-dialog-select__none" v-if="!items.length">
          Результатов не найдено
        </div>
      </div>
    </div>
    <UlCardFooter border>
      <UlBtnDefault
        @click="cancel"
      >
        {{labelCancel}}
      </UlBtnDefault>
      <UlBtnPrimary
        style="margin-left: 16px;"
        @click="submit"
        :disabled="!this.val"
      >
        {{labelSubmit}}
      </UlBtnPrimary>
    </UlCardFooter>
  </UlDialog>
</template>
<style lang="scss">
  .ul-dialog-select {
    &__wrap {
      height: 40vh;
      margin: -24px;
      overflow: auto;
    }

    &__filter {
      display: flex;
      background: rgba(0, 0, 0, .05);
      border-radius: 12px;

      input {
        padding-left: 8px;
        width: 100px;
      }

      i {
        padding: 6px;
      }
    }

    &__item {
      padding: 4px 0;
    }

    &__body {
      padding: 12px 24px;
    }

    &__none {
      text-align: center;
      font-size: 14px;
      color: #777777;
    }
  }
</style>
